import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useContentImages } from '@/hooks/useContentImages';

const Hero = () => {
  const { images } = useContentImages('hero');
  const heroImage = images[0];

  return (
    <section className="relative bg-gradient-to-br from-background via-accent/20 to-primary/5 min-h-screen flex items-center overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary/10 rounded-full blur-3xl animate-pulse-slow"></div>
        <div
          className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse-slow"
          style={{ animationDelay: '1s' }}
        ></div>
      </div>

      <div className="container-custom relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="animate-on-scroll">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-8">
              <Sparkles size={16} className="mr-2" />
              Leading IT Solutions Provider
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-8 leading-tight">
              IT Solutions That{' '}
              <span className="gradient-text">Drive Innovation</span>
            </h1>

            <p className="text-xl md:text-2xl text-muted-foreground mb-12 max-w-2xl leading-relaxed">
              Passionate IT service provider with expertise in Java, Python,
              JavaScript, ReactJS, WordPress, and PostgreSQL for all your
              technology needs.
            </p>

            <div className="flex flex-col sm:flex-row gap-6">
              <Link
                to="/contact"
                className="btn-primary group hover:!border-foreground hover:!text-primary hover:!bg-transparent transition-all duration-300"
              >
                Get Started
                <ArrowRight
                  size={20}
                  className="inline-flex items-center justify-center ml-2 transition-transform group-hover:translate-x-1"
                />
              </Link>
              <Link to="/services" className="btn-secondary">
                Explore Services
              </Link>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 mt-16 pt-8 border-t border-border/50">
              <div className="text-center">
                <div className="text-3xl font-bold text-primary mb-2">100+</div>
                <div className="text-sm text-muted-foreground">
                  Projects Delivered
                </div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-primary mb-2">50+</div>
                <div className="text-sm text-muted-foreground">
                  Happy Clients
                </div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-primary mb-2">5+</div>
                <div className="text-sm text-muted-foreground">
                  Years Experience
                </div>
              </div>
            </div>
          </div>

          <div className="animate-on-scroll flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary to-blue-600 rounded-3xl blur-2xl opacity-20 animate-pulse-slow"></div>
              <div className="relative glass-card rounded-3xl p-8 max-w-lg">
                <img
                  src={
                    heroImage?.image_url ||
                    'https://images.unsplash.com/photo-1461749280684-dccba630e2f6'
                  }
                  alt={heroImage?.alt_text || 'GoalTec IT Solutions'}
                  className="w-full rounded-2xl shadow-2xl animate-float"
                />

                {/* Floating Elements */}
                <div
                  className="absolute -top-4 -left-4 bg-primary text-primary-foreground p-4 rounded-2xl shadow-xl animate-float"
                  style={{ animationDelay: '0.5s' }}
                >
                  <div className="text-sm font-medium">Innovation</div>
                </div>
                <div
                  className="absolute -bottom-4 -right-4 bg-blue-600 text-white p-4 rounded-2xl shadow-xl animate-float"
                  style={{ animationDelay: '1s' }}
                >
                  <div className="text-sm font-medium">Excellence</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
